import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clocksNow, generateUUID } from '@datadog/browser-core';
import { ActionType as ActionTypeEnum, FrustrationType as FrustrationTypeEnum } from '../../rawRumEvent.types';
import { startEventTracker } from '../eventTracker';
import { isActionChildEvent } from './isActionChildEvent';
export function trackManualActions(lifeCycle, onManualActionCompleted) {
  var actionTracker = startEventTracker(lifeCycle);
  function startManualAction(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var startClocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : clocksNow();
    var _a;
    var lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
    var startedManualAction = actionTracker.start(lookupKey, startClocks, _objectSpread({
      name: name
    }, options), {
      isChildEvent: isActionChildEvent
    });
    lifeCycle.notify(15 /* LifeCycleEventType.ACTION_STARTED */, startedManualAction);
  }
  function stopManualAction(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stopClocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : clocksNow();
    var _a;
    var lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
    var stopped = actionTracker.stop(lookupKey, stopClocks, options);
    if (!stopped) {
      return;
    }
    var frustrationTypes = [];
    if (stopped.counts && stopped.counts.errorCount > 0) {
      frustrationTypes.push(FrustrationTypeEnum.ERROR_CLICK);
    }
    var manualAction = _objectSpread(_objectSpread({}, stopped), {}, {
      type: stopped.type || ActionTypeEnum.CUSTOM,
      frustrationTypes: frustrationTypes
    });
    onManualActionCompleted(manualAction);
  }
  function addInstantAction(action) {
    onManualActionCompleted(_objectSpread({
      id: generateUUID(),
      frustrationTypes: []
    }, action));
  }
  return {
    addAction: addInstantAction,
    startAction: startManualAction,
    stopAction: stopManualAction,
    findActionId: actionTracker.findId,
    stop: actionTracker.stopAll
  };
}